import organizationTypes from "astrid-firestore/src/api/organizations/constants/organizationTypes";

export function getAgreementAdminURL(agreement) {
	if (!agreement) {
		return null;
	}

	return `/agreements/${agreement.id}`;
}

export function getAgreementSecondPartyAdminURL(agreement) {
	if (!agreement) {
		return null;
	}

	if (agreement.secondParty.type === organizationTypes.PUBLISHER) {
		return `/${agreement.firstParty?.type}/${agreement.firstParty.id}/publishers/${agreement.secondParty.id}`;
	}

	return `/${agreement.firstParty?.type}/${agreement.firstParty?.id}/users/${agreement.secondParty.id}`;
}

export function getAgreementRenewAdminURL(agreement) {
	if (!agreement) {
		return null;
	}

	return `/${agreement.firstParty?.type}/${agreement.firstParty?.id}/finance/agreements/prepare/${agreement.id}`;
}
